/** Empty OTP slots are stored as spaces so digit positions align with cell indices. */
const EMPTY_SLOT = " ";

export function toOtpSlots(value: string, length: number): string[] {
  return Array.from({ length }, (_, i) => {
    const c = value[i];
    return c != null && /\d/.test(c) ? c : "";
  });
}

export function slotsToOtpValue(slots: string[]): string {
  return slots.map((d) => d || EMPTY_SLOT).join("");
}

export function displayOtpDigit(value: string, index: number): string {
  const c = value[index];
  return c != null && /\d/.test(c) ? c : "";
}

export function getFirstEmptyOtpIndex(value: string, length: number): number {
  for (let i = 0; i < length; i += 1) {
    if (!/\d/.test(value[i] ?? "")) return i;
  }
  return length - 1;
}

/** Digits only, in cell order (for API / validation). */
export function normalizeOtpValue(value: string): string {
  return value.replace(/\D/g, "");
}
